import React from 'react';

// working backwards, we want a return that has two functions - fromTenantTimezone and toTenantTimezone
// or, in the old names, utcToTenantToLocalDate and localDateToTenantToUtc
// which, yeah, the names kind of sucked and it was hard to remember which to use
// maybe... serverToLoca and localToServer? Doesn't mention the tenant at all, but perhaps that's just an implementation detail?

import { useGetMyDetails } from '../data/useGetMyDetails';
import {
  localDateToTenantToUtc,
  utcToTenantToLocalDate,
} from '../utils/date-utils';

export function useTenantTimezoneConversion() {
  const { data, loading } = useGetMyDetails();

  // in practical usage, this should NEVER change
  // even if the user changes (we occasionally re-run the query inside useGetMyDetails)
  // their timezone won't change
  // so, take a dep on the timezone string itself. Are string stable? I think strings are stable
  return React.useMemo(() => {
    return {
      loading,
      // pass thru to the utility functions - we now probably know the timezone. If not, there's a default
      localDateToTenantToUtc: (
        localDate: Parameters<typeof localDateToTenantToUtc>[0]
      ) => localDateToTenantToUtc(localDate, data?.tenant?.Timezone),
      utcToTenantToLocalDate: (
        utcDateAndTime: Parameters<typeof utcToTenantToLocalDate>[0]
      ) => utcToTenantToLocalDate(utcDateAndTime, data?.tenant?.Timezone),
    };
  }, [data?.tenant?.Timezone, loading]);
}

export type utcToTenantToLocalDateFunction = ReturnType<
  typeof useTenantTimezoneConversion
>['utcToTenantToLocalDate'];
